export default __webpack_public_path__ + "static/media/logowhite.82b37032.png";